
































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Swiper, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import illustrationSrc from '@/assets/img/cart-recommend/cart-recommend-illustration.svg';
import { RecommendItem, CART_RECOMMEND_TARGET_SCENE } from './recommend/types';

Swiper.use([Pagination]);

const VIEW_DURATION = 1000;
const VIEW_SESSION_KEY = 'form_list_cartRecommend_viewed';

@Component({})
export default class CartRecommendBanner extends Vue {
  @Prop({ default: () => [] })
  items!: RecommendItem[];

  @Prop({ default: false })
  dismissLoading!: boolean;

  illustrationSrc = illustrationSrc;

  swiper: Swiper | null = null;
  exposureObserver: IntersectionObserver | null = null;
  exposureTimer: number | null = null;
  hasReportedView = false;

  @Watch('items', { deep: true })
  onItemsChange() {
    this.$nextTick(() => {
      this.initSwiper();
      this.setupExposureObserver();
    });
  }

  mounted() {
    this.initSwiper();
    this.setupExposureObserver();
  }

  beforeDestroy() {
    this.teardownExposureObserver();
    this.destroySwiper();
  }

  initSwiper() {
    this.destroySwiper();
    // MVP 单卡无需 Swiper；且 Pagination 在 pagination 为 undefined 时会读 .el 报错
    if (this.items.length <= 1 || !this.$refs.swiperContainer) {
      return;
    }

    const paginationEl = this.$refs.paginationEl as HTMLElement | undefined;
    this.swiper = new Swiper(this.$refs.swiperContainer as HTMLElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  setupExposureObserver() {
    this.teardownExposureObserver();
    if (typeof IntersectionObserver === 'undefined' || !this.$refs.bannerRoot) {
      return;
    }

    this.exposureObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            this.startExposureTimer();
          } else {
            this.clearExposureTimer();
          }
        });
      },
      { threshold: [0, 0.5, 1] }
    );
    this.exposureObserver.observe(this.$refs.bannerRoot as Element);
  }

  teardownExposureObserver() {
    this.clearExposureTimer();
    if (this.exposureObserver) {
      this.exposureObserver.disconnect();
      this.exposureObserver = null;
    }
  }

  startExposureTimer() {
    if (this.hasReportedView || this.exposureTimer) {
      return;
    }
    this.exposureTimer = window.setTimeout(() => {
      this.reportViewOnce();
    }, VIEW_DURATION);
  }

  clearExposureTimer() {
    if (this.exposureTimer) {
      window.clearTimeout(this.exposureTimer);
      this.exposureTimer = null;
    }
  }

  reportViewOnce() {
    if (this.hasReportedView) {
      return;
    }
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id;
    const sessionKey = `${VIEW_SESSION_KEY}_${companyId || 'unknown'}`;
    if (sessionStorage.getItem(sessionKey)) {
      this.hasReportedView = true;
      return;
    }

    sessionStorage.setItem(sessionKey, '1');
    this.hasReportedView = true;
    window?.gtagClick?.('form_list_cartRecommend_view', '弹窗_列表_加购推荐曝光', [
      { key: 'targetScene', value: String(CART_RECOMMEND_TARGET_SCENE) },
      { key: 'company_id', value: String(companyId || '') },
    ]);
  }

  handlePreview(item: RecommendItem) {
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id;
    window?.gtagClick?.('form_list_cartRecommend_click', '弹窗_列表_加购推荐点击预览并开启', [
      { key: 'targetScene', value: String(item.scene || CART_RECOMMEND_TARGET_SCENE) },
      { key: 'company_id', value: String(companyId || '') },
    ]);
    this.$emit('preview', item);
  }

  handleDismiss(item: RecommendItem) {
    if (this.dismissLoading) {
      return;
    }
    this.$emit('dismiss', item);
  }
}
